import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { SparkleDecoration } from './ui/SparkleDecoration';
export function FinalCTASection() {
  return <section className="py-14 relative overflow-hidden bg-gradient-to-br from-coral to-[#d65b42]" data-id="element-53">
      {/* Decorative elements */}
      <div className="absolute top-5 left-5 opacity-30" data-id="element-54">
        <SparkleDecoration size={20} color="#FFFFFF" type="star" data-id="element-55" />
      </div>
      <div className="absolute bottom-5 right-5 opacity-30" data-id="element-56">
        <SparkleDecoration size={24} color="#FFFFFF" data-id="element-57" />
      </div>

      <div className="max-w-sm mx-auto px-4 text-center relative z-10" data-id="element-58">
        <AnimatedSection data-id="element-59">
          <h2 className="text-xl md:text-2xl font-serif font-bold text-white mb-4 leading-snug" data-id="element-60">
            La mamá que querés ser no está lejos. Solo necesita el sistema
            correcto.
          </h2>

          <p className="text-sm md:text-base text-white/85 mb-6 font-medium" data-id="element-61">
            Hoy podés cambiar tu situación por solo $19.999
          </p>

          <a href="#precio" className="inline-block bg-emerald-500 text-white px-6 py-3 rounded-full font-bold text-sm hover:scale-105 transition-transform duration-300 shadow-lg mb-3" data-id="element-62">
            SÍ, QUIERO EMPEZAR HOY CON 50% OFF
          </a>

          <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-63">
            <span className="bg-white/20 border border-white/30 text-white font-semibold text-xs px-3 py-1.5 rounded-full" data-id="element-64">
              ⚡ Acceso inmediato
            </span>
            <span className="bg-white/20 border border-white/30 text-white font-semibold text-xs px-3 py-1.5 rounded-full" data-id="element-65">
              📥 Descarga instantánea
            </span>
            <span className="bg-white/20 border border-white/30 text-white font-semibold text-xs px-3 py-1.5 rounded-full" data-id="element-66">
              🛡️ Garantía 7 días
            </span>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}